//this file is to create a dynamic manifest file for dynamic routes during shortcuts created on chrome
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useDynamicManifest() {
  const location = useLocation();

  useEffect(() => {
    const manifestData = {
      name: "Chronox AI",
      short_name: "Chronox AI",
      start_url: location.pathname,
      display: "standalone",
      background_color: "#ffffff",
      theme_color: "#000000",
      icons: [
        {
          src: "public\favicon.ico",
          sizes: "192x192",
          type: "image/png"
        }
      ]
    };

    // Create a blob URL from the manifest object
    const blob = new Blob([JSON.stringify(manifestData)], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);

    // Inject or update the manifest link tag
    let link = document.querySelector("link[rel='manifest']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.href = manifestURL;

    return () => URL.revokeObjectURL(manifestURL);
  }, [location.pathname]);
}